module.exports = __webpack_public_path__ + "img/0050.fe4e68de.jpg";